<template>
  <v-card class="pa-4">
    <p><span class="primary--text">Subject:</span> <span style="font-size: 18px;">{{ data.subject }}</span></p>
    <p><span class="primary--text">Message:</span> <span style="font-size: 18px;">{{ data.message }}</span></p>
    <p><span class="primary--text">Created On:</span> <span style="font-size: 18px;">{{ formatDate(data.createdOn) }}</span></p>
    <v-layout
      justify-space-between
      row>
      <v-btn
        class="elevation-0 mx-0" 
        @click="$emit('close')">
        Close
      </v-btn>
      <v-btn
        :disabled="data.isRead"
        class="elevation-0 mx-0" 
        color="primary"
        @click.prevent="markAsRead()">
        Mark as read
      </v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: undefined,
      },
    },
    data() {
      return {
        err: '',
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      markAsRead() {
          this.$http.post(`announcement/markasread/${this.data.id}`, {})
            .then((res) => {
              if (res.body.status === 'Success') {
                this.$emit('close');
              }
            }, (err) => {
              this.err = err.body.statusText || err.body.message;
            });
        },
    },
  }
</script>



// WEBPACK FOOTER //
// ShowSubject.vue?367e6ebb